import { connect } from 'react-redux'
import DeviceIdManager from './component'
import { setDeviceId } from '../../../../data'

function mapDispatchToProps(dispatch) {
    return {
        setDeviceId: (deviceId) => {
            console.info(`Device ID registered as ${deviceId}`)
            dispatch(setDeviceId(deviceId))
        },
    }
}

export default connect(null, mapDispatchToProps)(DeviceIdManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/DeviceIdManager/index.js